import React, { useState, useEffect } from 'react';
import {
    Grid,
    Card,
    Box,
    Typography,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainerEditRoutes";
import Container from "@mui/material/Container";
import Logo from "assets/images/skill2.png";
import MKButton from "components/MKButton";
import { useNavigate } from 'react-router-dom';
import MKTypography from "components/MKTypography";
import { LocationOn } from '@mui/icons-material';
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MKAlert from "components/MKAlert";
import '../../../styles.css';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
    return (
        <>
            {loading && (
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        filter: 'blur(5px)',
                        pointerEvents: 'none',
                    }}
                    open={loading}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            zIndex: "1",
                            width: "100%",
                            minHeight: "100vh",
                            // display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none',
                            userSelect: 'none',
                        }}
                    >
                        {children}
                    </Box>
                </Backdrop>
            )}
            {loading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: (theme) => theme.zIndex.drawer + 2,
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            {!loading && children}
        </>
    );
};

const TrainerCompletedTrainingSeeMore = () => {
    const [userId, setUserId] = useState("");
    const [loading, setLoading] = useState(false);
    const [completedTrainings, setCompletedTrainings] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        let id = localStorage.getItem("userId");
        console.log(id);
        let display = "card";
        let filterStatus = "completedTrainings";
        fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setCompletedTrainings(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [userId]);
    console.log("completedTrainings", completedTrainings);

    const onAppliedMoreDetailsClick = (training) => {
        console.log("training", training.appliedTrainingID);
        navigate(`/app/appliedtrainingmoredetails/${training.appliedTrainingID}/`);
    };

    function getStatusMessage(training) {
        console.log("training.applyTrainingStatus", training.applyTrainingStatus);
        if (training.applyTrainingStatus === "1") {
            return "Awaiting For Training Partner's response";
        } else if (training.applyTrainingStatus === "2") {
            return "Training Partner - Accepted. Awaiting for your response";
        } else if (training.applyTrainingStatus === "13") {
            return "Training Partner has Declined your request";
        } else if (training.applyTrainingStatus === "3") {
            return "Mutually agreed for the training";
        } else if (training.applyTrainingStatus === "14") {
            return "Trainer Declined the training";
        } else if (training.applyTrainingStatus === "4") {
            return "Discussion on-going with Training Partner";
        } else if (training.applyTrainingStatus === "5") {
            return "Training Scheduled - Awaiting for your Confirmation";
        } else if (training.applyTrainingStatus === "6") {
            return "Training Scheduling confirmed with Training Partner";
        } else if (training.applyTrainingStatus === "7") {
            return "Training has been Started";
        } else if (training.applyTrainingStatus === "8") {
            return "Training has been Completed";
        } else if (training.applyTrainingStatus === "9") {
            return "Invoice sent to the Training Partner";
        } else if (training.applyTrainingStatus === "10") {
            return "Payment Completed by the Training Partner";
        } else if (training.applyTrainingStatus === "11") {
            return "Training Completed and Payment Received";
        } else if (training.applyTrainingStatus === "12") {
            return "Payment not Received by the Trainer";
        } else if (training.applyTrainingStatus === "16") {
            return "Your training request is on-hold by Training Partner";
        } else if (training.applyTrainingStatus === "17") {
            return "1st New Payment Date given by Training Partner";
        } else if (training.applyTrainingStatus === "18") {
            return "2nd New Payment Date given by Training Partner";
        } else if (training.applyTrainingStatus === "19") {
            return "Final New Payment Date given by Training Partner";
        } else if (training.applyTrainingStatus === "20") {
            return "Final Completed by the Training Partner";
        } else {
            return "Unknown Status";
        }
    }

    const renderTrainerCards = (trainings) => {
        return trainings.map((training, index) => (
            <Grid item xs={6} key={training.id} >
                <div className="gridItemSeeMore">
                    <div className="gridContent">
                        <div className="trainingInfo">
                            <Typography variant="subtitle1" className="trainingName" ><strong>{training.trainingName}</strong></Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                                    {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {training.finalizedCommercialsCurrency}&nbsp;{training.finalizedCommercials} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong> Start Date : </strong> &nbsp;{training.trainingStartDate} |&nbsp;<strong> End Date : </strong> &nbsp;{training.trainingEndDate}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong> Schedule Type : </strong> &nbsp;{training.finalizedTrainingHour}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <CalendarMonthIcon style={{ marginBottom: '5px', marginRight: '5px' }} />
                                    {training.finalizedScheduledate
                                        ? training.finalizedScheduledate
                                            .replace(/[\[\]']/g, '')
                                            .split(', ')
                                            .map((date, index, array) => (
                                                <React.Fragment key={index}>
                                                    {date}
                                                    {index < array.length - 1 && (index === 3 ? <br /> : ', ')}
                                                </React.Fragment>
                                            ))
                                        : ''}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong> Payment Date : </strong> &nbsp;{training.expectedPaymentDate3 !== null
                                        ? training.expectedPaymentDate3
                                        : training.expectedPaymentDate2 !== null
                                            ? training.expectedPaymentDate2
                                            : training.expectedPaymentDate1 !== null
                                                ? training.expectedPaymentDate1
                                                : training.expectedPaymentDate}
                                </span>
                            </Typography>
                            <Typography style={{ fontSize: 'medium' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <strong> Status: {getStatusMessage(training)} </strong>
                                </span>
                            </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                            <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                        </div>

                    </div>
                </div>
            </Grid>
        ));
    };


    return (
        <>
            <LoadingOverlay loading={loading}>
            <IdleTimeOutHandler />
                <DefaultNavbar
                    routes={editRoutes}
                    sticky
                />
                <Card
                    sx={{
                        minHeight: '101vh',
                        height: 'auto',
                        p: 2,
                        mx: { xs: 2, lg: 3 },
                        mt: -8,
                        mb: 4,
                        // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                        backdropFilter: "saturate(200%) blur(30px)",
                        boxShadow: ({ boxShadows: { xxl } }) => xxl,
                    }}
                >
                    <Container>
                        <Grid container>
                            <Grid item xs={12} style={{ marginTop: "150px" }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                                        <Grid item xs={12} style={{ display: 'flex' }}>
                                            <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                                                <span style={{ color: 'black' }}>Completed</span>{' '}
                                                <span style={{ color: '#2e1114' }}>Trainings</span>
                                            </MKTypography>
                                        </Grid>
                                    </Grid>

                                    {completedTrainings.length === 0 ? (
                                        <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Trainings has been completed by you.</span>
                                    ) : (
                                        ""
                                    )}

                                    {completedTrainings.length === 0 ? (
                                        ""
                                    ) : (
                                        <Grid container spacing={2}>
                                            {renderTrainerCards(completedTrainings)}
                                        </Grid>
                                    )}

                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </Card>
            </LoadingOverlay>
        </>
    );
};

export default TrainerCompletedTrainingSeeMore;